function PlanGroupBrandCell(props) {
    return (
        <>{props.value?.product_h5?.map((obj) => obj.label).join(",") ?? "-"}</>
    );
}

export default PlanGroupBrandCell;
